module.exports = __webpack_public_path__ + "img/l_d2.f99bcb74.png";